goog.module('yext.developerapps.tableauconnector.AjaxActions');
goog.module.declareLegacyNamespace();

goog.require('yext.developerapps.tableauconnector.ConnectionData');
goog.require('yext.developerapps.routes');

class AjaxActions {
  constructor() {
    this.logMessage = this.logMessage.bind(this);

    this.getCookieToken = this.getCookieToken.bind(this);
    this.clearCookies = this.clearCookies.bind(this);

    this.setToken = this.setToken.bind(this);
    this.postJson = this.postJson.bind(this);
    this.getJson = this.getJson.bind(this);

    this.getCustomFields = this.getCustomFields.bind(this);
    this.getSchemaJson = this.getSchemaJson.bind(this);
    this.getAccountList = this.getAccountList.bind(this);
    this.getEntityData = this.getEntityData.bind(this);
    this.getReviewsData = this.getReviewsData.bind(this);
    this.getBatchedAnalyticsData = this.getBatchedAnalyticsData.bind(this);
    this.getAnalyticsData = this.getAnalyticsData.bind(this);
    this.getData = this.getData.bind(this);
    this.addToAnalyticsMap = this.addToAnalyticsMap.bind(this);
    this.convertAnalyticsMap = this.convertAnalyticsMap.bind(this);
  }

  setToken(token) {
    this.token = token;
  }

  postJson(url, data, callback) {
    return this.postJsonWithToken(url, data, '', callback);
  }

  postJsonWithToken(url, data, token, callback) {
    if (token) {
      url = url + '?access_token=' + token;
    }

    return $.ajax({
      'type': 'POST',
      'url': url,
      'async': false,
      'contentType': 'application/json',
      'data': data,
      'dataType': 'json',
      'success': callback,
    });
  }

  getJson(url, callback) {
    return this.getJsonWithToken(url, '', callback);
  }

  getJsonWithToken(url, token, callback) {
    if (token) {
      url = url + '?access_token=' + token;
    }
    return $.ajax({
      method: 'GET',
      url: url,
      async: false,
      dataType: 'json',
    }).done(callback);
  }

  logMessage(msg) {
    var url = yext.developerapps.routes.TableauConnector.logMessage();
    var data = JSON.stringify({message: 'JS: ' + msg});
    this.postJson(url, data);
  }

  getAppUrl() {
    var route = yext.developerapps.routes.TableauConnector.getAppUrl();
    var url = '';
    this.getJson(
      route,
      function(resp) {
        if (resp['data'] && resp['data'].length > 0) {
          url = resp['data'];
        }
      },
    );
    return url;
  }

  getOauthURL() {
    var route = yext.developerapps.routes.TableauConnector.getOAuthUrl();
    var url = '';
    this.getJson(
      route,
      function(resp) {
        if (resp['data'] && resp['data'].length > 0) {
          url = resp['data'];
        }
      },
    );
    return url;
  }

  getClientId() {
    var route = yext.developerapps.routes.TableauConnector.getClientId();
    var clientId = '';
    this.getJson(
      route,
      function(resp) {
        if (resp['clientId'] && resp['clientId'].length > 0) {
          clientId = resp['clientId'];
        }
      },
    );
    return clientId;
  }

  getWdcUrl() {
    var route = yext.developerapps.routes.TableauConnector.getWdcUrl();
    var url = '';
    this.getJson(
      route,
      function(resp) {
        if (resp['data'] && resp['data'].length > 0) {
          url = resp['data'];
        }
      },
    );
    return url;
  }

  getCookieToken() {
    var route = yext.developerapps.routes.TableauConnector.getCookieToken();
    var accessToken = '';

    this.getJson(
      route,
      function(resp) {
        if (resp['token'] && resp['token'].length > 0) {
          accessToken = resp['token'];
        }
      },
    );
    return accessToken;
  }

  clearCookies() {
    var route = yext.developerapps.routes.TableauConnector.clearCookies();
    var success = false;

    this.getJson(
      route,
      function(resp) {
        success = resp['success'];
      },
    );
    return success;
  }

  getSchemaJson() {
    var route = yext.developerapps.routes.TableauConnector.getSchema();
    var schemaJson;
    this.getJson(
      route,
      function(resp) {
        schemaJson = resp;
      },
    );
    this.logMessage('Schema returned to JS');
    return schemaJson;
  }

  getCustomFields() {
    var customFields;
    var route = yext.developerapps.routes.TableauConnector.getCustomFields();
    this.getJsonWithToken(
      route,
      this.token,
      function(resp) {
        customFields = resp.response.data;
      },
    );
    return customFields;
  }

  getAccountList() {
    this.logMessage('Getting account list data...');
    var route = yext.developerapps.routes.TableauConnector.getAccountList();
    var accountList;
    this.getJsonWithToken(
      route,
      this.token,
      function(resp) {
        accountList = resp.response.data;
      });
    this.logMessage('Got # accounts: ' + Object.keys(accountList).length);
    return accountList;
  }

  getEntityData() {
    var accountList = this.getAccountList();
    if (accountList.length == 0) {
      throw new Error('Account List Empty');
    }

    this.logMessage('Getting entity data...');
    var route = yext.developerapps.routes.TableauConnector.getEntityData();
    var entityData = [];

    // For each sub-account
    for (var id in accountList) {
      this.logMessage('Getting locations for account: ' + accountList[id]);
      var offset = 0;
      while (offset != null) {
        this.getJsonWithToken(
          route,
          this.token + '&offset=' + offset + '&accountId=' + accountList[id],
          function(resp) {
            entityData = entityData.concat(resp.data);
            offset = resp['nextOffset'];
          });
        this.logMessage('Got # entities: ' + Object.keys(entityData).length);
      }
    }
    return entityData;
  }

  getReviewsData(connectionData) {
    this.logMessage('Getting reviews data...');
    var reviewsData = [];
    var route = yext.developerapps.routes.TableauConnector.getReviewsData();
    var requestJSON = JSON.stringify(connectionData);
    var offset = 0;

    while (offset != null) {
      this.postJsonWithToken(
        route,
        requestJSON,
        this.token + '&offset=' + offset,
        function(resp) {
          reviewsData = reviewsData.concat(resp.data);
          offset = resp['nextOffset'];
        },
      );
      this.logMessage('Got # reviews: ' + Object.keys(reviewsData).length);
    }
    return reviewsData;
  }

  getBatchedAnalyticsData(connectionData, route, metricBatches, yextDimensions, tableauDimensions) {
    var metricsMap = {};
    metricBatches.forEach(batch =>
      this.getData(connectionData, route, metricsMap, batch, yextDimensions, tableauDimensions));
    var metricsData = this.convertAnalyticsMap(metricsMap);
    this.logMessage('Got # rows: ' + Object.keys(metricsData).length);
    return metricsData;
  }

  getAnalyticsData(connectionData, route, metrics, yextDimensions, tableauDimensions) {
    var dataMap = this.getData(connectionData, route, {}, metrics, yextDimensions, tableauDimensions);
    var parsedData = this.convertAnalyticsMap(dataMap);
    this.logMessage('Got # rows: ' + Object.keys(parsedData).length);
    return parsedData;
  }

  getData(connectionData, route, map, metrics, yextDimensions, tableauDimensions) {
    var data = [];
    var requestJSON = JSON.stringify(connectionData);
    var dimensions = yextDimensions;
    var tableauMetrics = metrics;
    // these Google dimensions only apply to a single metric in our system, so aren't part of
    // yextDimensions, which are the dimensions we include in our analytics request.
    // in Tableau, we're splitting the metric into multiple metrics based on the dimension value
    if (metrics.length == 1) {
      if (metrics.includes('GOOGLE_SEARCH_QUERIES')) {
        dimensions = yextDimensions.concat(['GOOGLE_QUERY_TYPE']);
        tableauMetrics = ['GOOGLE_SEARCH_QUERIES_DIRECT', 'GOOGLE_SEARCH_QUERIES_DISCOVERY'];
      } else if (metrics.includes('GOOGLE_CUSTOMER_ACTIONS')) {
        dimensions = yextDimensions.concat(['CUSTOMER_ACTION_TYPE']);
        tableauMetrics = ['GOOGLE_CUSTOMER_ACTIONS_GET_DIRECTIONS',
          'GOOGLE_CUSTOMER_ACTIONS_PHONE_CALLS', 'GOOGLE_CUSTOMER_ACTIONS_WEBSITE_CLICKS'];
      }
    }

    this.postJsonWithToken(
      route,
      requestJSON,
      this.token + '&metrics=' + metrics.join() + '&dimensions=' + dimensions.join(),
      function(resp) {
        data = data.concat(resp.response.data);
      },
    );
    this.logMessage('Response Data Size: ' + Object.keys(data).length);
    this.addToAnalyticsMap(data, map, tableauMetrics, tableauDimensions);
    return map;
  }

  addToAnalyticsMap(responseList, analyticsMap, batch, dimensions) {
    responseList.forEach(row =>
      this.parseRow(row, dimensions, batch, analyticsMap, this.getAnalyticsDisplayNames()));
  }

  parseRow(row, dimensions, batch, analyticsMap, displayNames) {
    var key = dimensions.map(dimension => row[dimension]);
    if (!analyticsMap[key]) {
      analyticsMap[key] = row;
      return;
    }
    var entry = analyticsMap[key];
    batch.map(metric => displayNames[metric] || metric)
      .filter(name => name != null && name.length > 0)
      .filter(name => typeof entry[name] === 'undefined' || typeof row[name] !== 'undefined')
      .forEach(name => entry[name] = row[name]);
  }

  convertAnalyticsMap(analyticsMap) {
    return Object.keys(analyticsMap).map(key => analyticsMap[key]);
  }

  checkValidToken(password) {
    var route = yext.developerapps.routes.TableauConnector.checkValidToken();
    var isValid;
    this.getJsonWithToken(
      route,
      password,
      function(resp) {
        isValid = resp['status'] == 'success' ? true : false;
      },
    );
    return isValid;
  }

  // only add metric's request id to response id to this map if it's part of a batched request
  // because we have to combine the responses. otherwise, setting the yextId to the responseId in
  // the schema is sufficient
  // analytics is moving towards the request and response ids being identical, so future metrics
  // may have the same key and value
  getAnalyticsDisplayNames() {
    var names = {
      // analytics metrics batch 1
      'PROFILE_VIEWS': 'Profile Views',
      'SEARCHES': 'Searches',
      'FEATURED_MESSAGE_CLICKS': 'Featured Message Clicks',
      // analytics metrics batch 2
      'YELP_PAGE_VIEWS': 'Yelp Page Views',
      // analytics metrics batch 3
      'FACEBOOK_LIKES': 'Facebook Likes',
      'FACEBOOK_TALKING_ABOUT': 'Facebook Talking About This',
      'FACEBOOK_CHECKINS': 'Facebook Check-ins',
      'FACEBOOK_PAGE_VIEWS': 'Facebook Page Views',
      'FACEBOOK_CTA_CLICKS': 'Facebook CTA Clicks',
      // analytics metrics batch 4
      'FACEBOOK_EVENT_NEW_RSVPS': 'Facebook Event New RSVPs',
      'FACEBOOK_IMPRESSIONS': 'Facebook Page Impressions',
      'FACEBOOK_POST_IMPRESSIONS': 'Facebook Post Impressions',
      'FACEBOOK_WERE_HERE': 'Were Here',
      // analytics metrics batch 7
      'GOOGLE_SEARCH_VIEWS': 'Google Search Views',
      'GOOGLE_MAP_VIEWS': 'Google Maps Views',
      // analytics metrics batch 8
      'GOOGLE_SEARCH_QUERIES_DIRECT': 'Google Search Queries - Direct',
      'GOOGLE_SEARCH_QUERIES_DISCOVERY': 'Google Search Queries - Discovery',
      // analytics metrics batch 9
      'GOOGLE_CUSTOMER_ACTIONS_GET_DIRECTIONS': 'Google Customer Actions - Get Directions',
      'GOOGLE_CUSTOMER_ACTIONS_PHONE_CALLS': 'Google Customer Actions - Phone Calls',
      'GOOGLE_CUSTOMER_ACTIONS_WEBSITE_CLICKS': 'Google Customer Actions - Website Clicks',
      // analytics metrics batch 10
      'GOOGLE_USER_PHOTOS': 'Google User Photos',
      'GSC_CLICKS': 'Google Search Clicks',
      'GSC_CTR': 'Google Search Click Through Rate',
      'GSC_IMPRESSIONS': 'Google Search Impressions',
      'GSC_POSITION': 'Google Search Average Position',
      // analytics metrics batch 11
      'AVERAGE_RATING': 'Average Rating',
      'NEW_REVIEWS': 'Reviews',
      // analytics metrics batch 12
      'STOREPAGES_SESSIONS': 'Sessions',
      'STOREPAGES_PAGEVIEWS': 'Pages Views',
      'STOREPAGES_DRIVINGDIRECTIONS': 'Driving Directions',
      'STOREPAGES_PHONECALLS': 'Taps to Call',
      'STOREPAGES_CALLTOACTIONCLICKS': 'Call to Action Clicks',
      'STOREPAGES_CLICKSTOWEBSITE': 'Clicks to Website',
      // analytics metrics batch 13
      'CLICKS': 'CLICKS',
      'CONVERSIONS': 'CONVERSIONS',
      'CONVERSION_RATE': 'CONVERSION_RATE',
      'CONVERSION_VALUE': 'CONVERSION_VALUE',
      'VALUE_PER_CONVERSION': 'VALUE_PER_CONVERSION',
      // analytics metrics batch 14
      'IST_AD_MATCHES': 'Ad Matches',
      'IST_AD_PRESENCE': 'Ad Presence',
      'IST_AVERAGE_FIRST_LOCAL_PACK_MATCH_POSITION': 'Average First Local Pack Match Position',
      'IST_AVERAGE_FIRST_MATCH_POSITION': 'Average First Match Position',
      'IST_AVERAGE_FIRST_ORGANIC_MATCH_POSITION': 'Average First Organic Match Position',
      // analytics metrics batch 15
      'IST_AVERAGE_LOCAL_PACK_NUMBER_OF_RESULTS': 'Average Local Pack Number of Results',
      'IST_AVERAGE_LOCAL_PACK_POSITION': 'Average Local Pack Position',
      'IST_KNOWLEDGE_CARD_EXISTED': 'Knowledge Card Existed',
      'IST_LOCAL_PACK_EXISTED': 'Local Pack Existed',
      'IST_LOCAL_PACK_PRESENCE': 'Local Pack Presence',
      // analytics metrics batch 16
      'IST_LOCAL_PACK_SHARE_OF_SEARCH': 'Local Pack Share of Search',
      'IST_MATCHES_PER_SEARCH': 'Matches per Search',
      'IST_ORGANIC_SHARE_OF_SEARCH': 'Organic Share of Search',
      'IST_SEARCH_REQUESTS': 'Search Requests',
      'IST_SHARE_OF_INTELLIGENT_SEARCH': 'Share of Intelligent Search',
      'IST_TOTAL_MATCHES': 'Total Matches',
      // analytics metrics batch 17
      'KEYWORD_MENTIONS': 'Keyword Mentions',
      'KEYWORD_SENTIMENT': 'Keyword Sentiment',
      // analytics metrics batch 18
      'LISTINGS_LIVE': 'New Listings Live',
      'POWERLISTINGS_LIVE': 'Active Listings Live',
      // analytics metrics batch 19
      'PROFILE_UPDATES': 'Profile Updates',
      'TICKET_CLICKS': 'Ticket Clicks',
      'SOCIAL_ACTIVITIES': 'Social Posts',
      'PUBLISHER_SUGGESTIONS': 'Publisher Suggestions',
      // analytics metrics batch 20
      'DUPLICATES_DETECTED': 'Duplicates Detected',
      'DUPLICATES_SUPPRESSED': 'Duplicates Suppressed',
      // analytics metrics batch 21
      'EVENT_PROFILEVIEWS': 'Event Profile Views',
      'EVENT_SEARCHES': 'Event Searches',
      // analytics metrics batch 22
      'YELP_CUSTOMER_ACTIONS': 'Yelp Customer Actions',
    };
    return names;
  }
}

exports = AjaxActions;
